import { adminsService } from '../index'

export const adminsQuery = () => ({
  queryKey: ['admins'],
  queryFn: () => adminsService.getAdmins()
})
